import React from "react";
import Card from "./Card";
import { styleLevel } from "../helpers/levelStyle";


export default function Cards({ cards, handleChoice, choiceOne, choiceTwo, disabled, level }) {


  return (
    <div className="card-memory-grid" style={styleLevel[level].cardGrid}>
      {cards.map((card, index) => {
        return <Card
          card={card}
          key={index}
          handleChoice={handleChoice}
          flipped={card === choiceOne || card === choiceTwo || card.matched}
          disabled={disabled}
          level={level}
        />
      })}
    </div>
  );
}